import React, { useEffect, useState } from 'react';
import validator from 'validator';

import './viewBody.scss';
import CrudView from '../components/Crud/CrudView';
import ValidatingInput from '../components/ValidatingInput/ValidatingInput';
import CountrySelector from '../components/CountrySelector/CountrySelector';
import { OrganizationClientSegment, clientSegments } from '../components/OrganizationClientSegment/OrganizationClientSegment';
import { OrganizationType } from '../components/OrganizationType/OrganizationType';
import OrganizationParent from '../components/OrganizationParent/OrganizationParent';

export default function OrganizationCrudView(props) {
    const [filters, setFilters] = useState([
        {
            id: 'showDeleted',
            name: 'Deleted',
            icon: 'filter_list',
            value: false,
            buttonType: 'negative',
            filterFn: (items, filter) => {
                if (!filter.value) {
                    return items.filter(it => it.status !== 'Deleted');
                }
                return items;
            },
            buttonClick: showDeleted,
        },
    ]);

    const columns = [
        {
            key: 'id',
            header: 'Id',
            width: '200px',
        },
        {
            key: 'name',
            header: 'Name',
        },
        {
            key: 'country',
            header: 'Country',
            content: (val, item) => {
                return val ? val: "";
            },
            sortFn: (a, b) => {
                const s1 = a.country ? a.country : "";
                const s2 = b.country ? b.country : "";
                return s1.localeCompare(s2);
            },            
            width: '120px',
        },
        {
            key: 'resellerId',
            header: 'Reseller',
            content: (val, item) => {
                return val ? val: "";
            },
            sortFn: (a, b) => {
                const s1 = a.resellerId ? a.resellerId : "";
                const s2 = b.resellerId ? b.resellerId : "";
                return s1.localeCompare(s2);
            },
        },
        {
            key: 'clientSegment',
            header: 'Client Segment',
            content: (val, item) => {
                console.log(val,item)
                return val !== null && val >= 0 && val < 7 ? clientSegments[val]?.label: "";
            },
            sortFn: (a, b) => {
                const s1 = a.clientSegment && a.clientSegment >= 0 && a.clientSegment < 7 ? clientSegments[a.clientSegment] : "";
                const s2 = b.clientSegment && b.clientSegment >= 0 && b.clientSegment < 7 ? clientSegments[b.clientSegment] : "";
                return s1.localeCompare(s2);
            },
        },

        {
            key: 'parentId',
            header: 'Parent',
            content: (val, item) => {
                return val !== null ? val: "";
            },
            sortFn: (a, b) => {
                const s1 = a.parentId ? a.parentId : "";
                const s2 = b.parentId ? b.parentId : "";
                return s1.localeCompare(s2);
            },
        },                  
        {
            key: 'status',
            header: 'Status',
            content: (val, item) => {
                if (val === 'Deleted') {
                    return <span style={{ color: 'red' }}>{val}</span>;
                }
                return <span style={{ color: 'green' }}>{val}</span>;
            },
            width: '100px',
        },
    ];

    function showDeleted(origFilter) {
        const filter = { ...origFilter };
        filter.value = !filter.value;
        filter.buttonType = filter.value ? 'positive' : 'negative';
        setFilters(
            filters.map(fl => {
                if (fl.id !== filter.id) return fl;
                return filter;
            })
        );
    }

    return <CrudView serviceId="OrganizationService" form={OrganizationForm} title="Organization" columns={columns} filters={filters}></CrudView>;
}

/**
 * Organization Form for creating new organizations and editing them
 * @param {*} props
 */
function OrganizationForm(props) {
    const [invFields, setInvalidFields] = useState([]);
    const [organizationData, setOrganizationData] = useState(() => {
        if (props.item) {
            const data = { ...props.item };
            data.streetAddress = data.streetAddress !== null ? data.streetAddress : '';
            data.city = data.city !== null ? data.city : '';
            data.country = data.country !== null ? data.country : '';
            data.resellerId = data.resellerId !== null ? data.resellerId : '';
            data.metadata = data.metadata.raw === undefined || data.metadata.raw === null ? '{}' : JSON.stringify(data.metadata.raw);
            data.clientSegment = data.clientSegment || null; // nullable
            data.type = data.type || null; // nullable
            data.parentId = data.parentId !== null ? data.parentId : null;  // nullable
            return data;
        }
        return {
            name: 'Default name',
            status: 'Active',
            id: null,
            metadata: '{}',
        };
    });

    function isValidString(val, minLen, maxLen, mandatory = false) {
        if (typeof val !== 'string') return false;
        if (mandatory || val.length > 0) {
            if (val.length < minLen || val.length > maxLen) return false;
            return true;
        }
        return true;
    }

    function isValidIdString(val, minLen = 3, maxLen = 1000, mandatory = false) {
        if (typeof val !== 'string') return false;
        if (validator.matches(val, '[*!{}|<>,:´`%&?=()#$"/\\\\]')) return false;
        if (mandatory || val.length > 0) {
            if (val.length < minLen || val.length > maxLen) return false;
            return true;
        }
        return true;
    }

    useEffect(() => {
        const invalidFields = [];

        !isValidIdString(organizationData.id, 3, 1000, true) && invalidFields.push('id');
        !isValidString(organizationData.name, 3, 1000, true) && invalidFields.push('name');
        !isValidString(organizationData.streetAddress, 3, 1000) && invalidFields.push('streetAddress');
        !isValidString(organizationData.city, 3, 40) && invalidFields.push('city');
        !isValidString(organizationData.country, 2, 2, true) && invalidFields.push('country');
        !isValidString(organizationData.resellerId, 3, 1000, false) && invalidFields.push('resellerId');

        if (JSON.parse(organizationData.metadata)) props.onChange(organizationData, invalidFields.length === 0);
        setInvalidFields(invalidFields);
        // eslint-disable-next-line
    }, [organizationData, props.onChange]);

    // function onToggleChange(value, name) {
    //     const newData = typeof organizationData === 'object' ? { ...organizationData } : {};
    //     newData[name] = value;
    //     // props.onChange(newData);
    //     setOrganizationData(newData);
    // }

    function changeValue(key, value, valid) {
        const newData = typeof organizationData === 'object' ? { ...organizationData } : {};
        newData[key] = value;
        // props.onChange(newData);
        setOrganizationData(newData);
    }

    function onCountryChange(key, value) {
        const newData = typeof organizationData === 'object' ? { ...organizationData } : {};
        newData[key] = value.value;
        // props.onChange(newData);
        setOrganizationData(newData);
    }

    function onClientSegmentChange(key, newClientSegment) {
        const newData = typeof organizationData === 'object' ? { ...organizationData } : {};
        newData[key] = newClientSegment.id;
        setOrganizationData(newData);
    }

    function onTypeChange(key, newType) {
        const newData = typeof organizationData === 'object' ? { ...organizationData } : {};
        newData[key] = newType.id;
        setOrganizationData(newData);
    }

    function onParentChange(key, newParent) {
        const newData = typeof organizationData === 'object' ? { ...organizationData } : {};
        newData[key] = newParent.value;
        setOrganizationData(newData);
    }

    // function updateMetadata(key, value) {
    //     const newData = typeof organizationData === 'object' ? { ...organizationData } : {};
    //     newData.metadata = value.value;
    //     // props.onChange(newData);
    //     setOrganizationData(newData);
    // }

    return (
        <div className="crud-form-container">
            {invFields.length > 0 && (
                <div className="crud-validation-errors">
                    There are invalid field values or mandatory fields are missing.
                    <br />
                    Invalid fields are: {invFields.join(', ')}.
                </div>
            )}

            {props.crudState.viewMode === 'NEW' && (
                <div className="crud-input">
                    <ValidatingInput
                        label="Organization Id"
                        dataSet={organizationData}
                        dataKey="id"
                        onChange={changeValue}
                        validationType="string"
                        validationFn={isValidIdString}
                    />
                    <div className="crud-help">Unique ID for the organization</div>
                </div>
            )}

            <div className="crud-input">
                <ValidatingInput label="Name" dataSet={organizationData} dataKey="name" onChange={changeValue} validationType="string" />
                <div className="crud-help">Name of the organization</div>
            </div>

            {/* <div className="crud-input">
                <div className="se-input-container">
                    <label className="se-label se-lable--md">Active</label>
                    <Toggle
                        label="Active"
                        isActive={organizationData.status === 'Active'}
                        onChange={val => {
                            onToggleChange(val ? 'Active' : 'Inactive', 'status');
                        }}
                    />
                </div>
            </div> */}

            <div className="crud-input with-group">
                <div className="input-group">
                    <ValidatingInput label="Street Address" dataSet={organizationData} dataKey="streetAddress" onChange={changeValue} validationType="string" />

                    <ValidatingInput label="City" dataSet={organizationData} dataKey="city" onChange={changeValue} validationType="string" />

                    <CountrySelector label="Country" dataSet={organizationData} dataKey="country" onChange={onCountryChange} />

                    <ValidatingInput label="Reseller" dataSet={organizationData} dataKey="resellerId" onChange={changeValue} validationType="string" />

                    <OrganizationClientSegment label="Client Segment" dataSet={organizationData} dataKey="clientSegment" onChange={onClientSegmentChange} />

                    <OrganizationType label="Type" dataSet={organizationData} dataKey="type" onChange={onTypeChange} />

                    <OrganizationParent label="Parent" serviceId={props.crudState.serviceId} dataSet={organizationData} dataKey="parentId" onChange={onParentChange} />
                    
                    {/* <ValidatingInput label="Country" dataSet={organizationData} dataKey="country" onChange={changeValue} validationType="string" /> */}
                </div>
                <div className="crud-help">The main address of the organization</div>
            </div>

            {/*          
            <div className="crud-input">
                <ValidatingInput label="Meta data as json" dataKey="metadata" dataSet={organizationData} onChange={updateMetadata} validationType="json" />

                <div className="crud-he">Meta data as Json file</div>
            </div> 
            */}
        </div>
    );
}
